import React, { useEffect, useState } from "react";
import { FaDownload } from "react-icons/fa";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


const AnnualReport = () => {
  const pageid = 1; // <-- change this to the correct pageid for Annual Reports
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch annual reports
  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();
        console.log("Annual Report API result:", result);

        if (!result.success || !Array.isArray(result.data)) {
          setReports([]);
          return;
        }

        // Map API data to desired format
        const formatted = result.data.map((item) => ({
          label: item.pdf_name,
          file: item.upload_file_path,
        }));

        setReports(formatted);
      } catch (error) {
        console.error("Fetch failed:", error);
        setReports([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  return (
    <>
      <Helmet>
        <title>Annual Reports | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      <div>
        {/* Hero Section */}
        <div className="relative w-full">
          <img
            src="./imgs/investors/investorannual.png"
            alt="Chiripal Group Banner"
            className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center">
            <div className="px-4 sm:px-8 md:px-24 lg:px-32">
              <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-7xl font-bold font-montserrat">
                Annual Reports
              </h1>
            </div>
          </div>
        </div>

        {/* PDF Section */}
        <div className="py-12 px-4 sm:px-8 md:px-16 lg:px-24 font-signika max-w-8xl mx-auto">
          {loading ? (
            <p>Loading annual reports...</p>
          ) : reports.length === 0 ? (
            <p>No annual reports found.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {reports.map((report, index) => (
                <div key={index} className="text-center">
                  <h3 className="font-semibold text-lg text-[#0b3a6a] mb-2">
                    {report.label}
                  </h3>
                  <a
                    href={`${API_PDF_URL}/${report.file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#0b3a6a] font-semibold flex items-center justify-center gap-2 hover:text-blue-800"
                  >
                    Download <FaDownload />
                  </a>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AnnualReport;
